module.exports = __webpack_public_path__ + "static/img/greencallIcon.efca2d7.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/xinyuan/greencallIcon.png
// module id = 8Pxw
// module chunks = 0